import React from 'react';
import PropTypes from 'prop-types';

export const BebopFeaturesCard = ({ content }) => {
  const { title, handsetImage, text, icon } = content;

  return (
    <div className="bebop-features__content col-xs-12 col-sm-4">
      <img
        className="bebop-features__content__handset-image"
        src={handsetImage}
        alt={title}
      />
      <div className="bebop-features__content__icon start-xs">
        <img src={icon} alt={title} />
      </div>
      <h3 className="bebop-features__content__description-title start-xs">
        {title}
      </h3>
      <p className="bebop-features__content__description-text start-xs">
        {text}
      </p>
    </div>
  );
};

BebopFeaturesCard.propTypes = {
  content: PropTypes.shape({
    handsetImage: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
  }),
};
